import { render } from "./SwipeButton.vue?vue&type=template&id=744f9f1d&scoped=true"
import script from "./SwipeButton.vue?vue&type=script&lang=js"
export * from "./SwipeButton.vue?vue&type=script&lang=js"

import "./SwipeButton.vue?vue&type=style&index=0&id=744f9f1d&lang=css&scoped=true"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744f9f1d"]])

export default __exports__